export const getRelativeUri = url => {
  return url.replace(/^.*\/\/[^/]+/, '');
};
